<!--已选商品信息-->
<template>
  <!--服务商品不需要选规格-->
  <div
    id="detailInfos"
    class="detail-infos"
    v-track="{
      act: 'show',
      params: {
        cfrom: '178|001|02|077',
        event_id: '178|001|02|077',
        page_name: 1,
        sku_id: skuId
      }
    }"
    v-if="spuInfo && goodsType != 3"
  >
    <v-list-view name="已选" @click="showSelect" right-icon="arrow-right-v3">
      <div class="content">
        <span v-for="item in checkTxt" :key="item" class="content-item">
          <span>{{ item }}</span>
        </span>
      </div>
    </v-list-view>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
export default {
  name: 'SelectParams',
  data() {
    return {
      suiteId: 0 // 选中的套餐Id
    }
  },
  props: {
    skuInfo: Object,
    spuInfo: Object
  },
  computed: {
    ...mapState('detailv3', ['selectParams', 'skuSelectParams', 'spuQuery']),
    ...mapGetters('detailv3', ['skuId', 'goodsType']),
    // 分别对应 会员,拼团,定金,全款,抢购,大促,正常
    discountType() {
      return this.skuInfo?.commoditySkuDiscount?.commodityDiscountType || 'normal'
    },
    // 是否是拼团活动调起的弹层（活动类型为拼团，且调起位置不是单独购买
    isGroup() {
      return this.discountType == 'group' && this.skuSelectParams?.source != 8
    },
    laserInfo() {
      return this.skuInfo?.commodityActivities?.find(item => item.actType == '2')
    },
    // 以上三条控制镭雕显示
    // 当前sku的套餐集合
    suites() {
      return this.skuInfo.commoditySkuDiscount?.commoditySuite
    },
    // 当前选中的套餐信息
    currentSuite() {
      if (this.suites && this.suites.length) {
        const suiteId = this.spuQuery?.suiteId || this.$route.query.suiteId || this.suiteId
        if (suiteId == 0) {
          return {
            id: 0,
            name: '官方标配',
            totalPrice: 0
          }
        } else {
          return this.suites.find(suite => suite.id == suiteId) || {}
        }
      }

      return {}
    },
    params() {
      if (!this.spuInfo || !this.spuInfo.specItem) {
        return {
          number: 1,
          currentSuite: {},
          service: {},
          name: '',
          laser: false
        }
      }
      let specData = { name: '' }
      let checkedSpecItem = {}
      let { specMain, skuSpecList, specItemSeq } = this.spuInfo?.specItem
      let skuId = this.skuInfo?.commoditySkuBaseInfo?.skuId
      // 根据skuId找到对应的sku项
      const currentSku = skuSpecList.find(item => item.skuId == skuId)
      let skuSpecs = {}
      if (currentSku) {
        skuSpecs = currentSku.sequences
      }
      specMain.forEach(specId => {
        // 当前sku不存在的话，则选中项初始化为空值
        const specItemId = skuSpecs[specId] || ''
        let specItemName = ''
        if (specItemId) {
          specItemName = specItemSeq[specId][specItemId - 1].name
        }
        this.$set(checkedSpecItem, specId, {
          id: specItemId,
          name: specItemName
        })
      })
      let isSku = specMain.every(specId => !!(checkedSpecItem[specId] && checkedSpecItem[specId].id))
      if (isSku) {
        specData.name = specMain.map(specId => checkedSpecItem[specId].name).join(' ')
      }
      return {
        number: 1,
        currentSuite: this.currentSuite,
        service: {},
        name: specData.name
      }
    },
    checkTxt() {
      let text = []
      let { name, service, number, currentSuite, laser } = this.selectParams
      // 规格名

      if (name?.indexOf('@') > -1) {
        name = name.replace(/@/, ' ')
      }
      // 加入数量
      text.push(name + ' ' + number + '件')
      // 如果有套餐，显示套餐名
      if (this.suites.length > 0 && !this.isGroup) {
        if (currentSuite?.id) {
          text.push(currentSuite.name)
        } else {
          text.push('可选套餐')
        }
      }
      // 如果选中了服务，分别加入服务名
      if (this.spuInfo.commoditySvcs?.length > 0) {
        var idArr = this.spuInfo.commoditySvcs.map(item => {
          return item.id
        })
        if (Object.values(service).length > 0) {
          var valArr = Object.values(service)
          var backArr = valArr.map(item => {
            return item.id
          })
          var arr = []
          for (var i = 0; i < idArr.length; i++) {
            if (backArr.indexOf(idArr[i]) > -1) {
              arr.push(idArr[i])
            }
          }
          var newArr = []
          arr.forEach(item => {
            valArr.forEach(inside => {
              if (item == inside.id) {
                newArr.push(inside)
              }
            })
          })
          let serviceNames = newArr.map(item => item.name)
          text = text.concat(serviceNames)
        } else {
          if (text.indexOf('可选套餐') > -1) {
            text.splice(text.indexOf('可选套餐'), 1)
            text.push('可选套餐、服务')
          } else {
            text.push('可选服务')
          }
        }
      }
      if (this.laserInfo && !this.isGroup) {
        if (laser) {
          text.push('免费雕刻服务')
        } else {
          if (this.goodsType == 1) {
            text.push('可定制您的专属手机')
          } else {
            text.push('可定制您的专属商品')
          }
        }
      }
      // return text.join(' ')
      return text
    }
  },
  created() {
    var obj = JSON.parse(JSON.stringify(this.params))
    obj.fqNum = 0
    obj.laser = false
    // TODO:初始化加购商品为空数组
    obj.additionCommodity = []
    this.$store.commit('detailv3/UPDATE_SELECT_PAEAMS', obj)
  },
  methods: {
    ...mapActions('detailv3', ['showSkuSelect', 'savePreFocusElByEvent']),
    showSelect(e) {
      this.savePreFocusElByEvent(e)
      this.showSkuSelect({ isShow: true, params: { source: 1 } })
      this.$track({
        cfrom: '178|001|01|077',
        event_id: '178|001|01|077',
        page_name: 1,
        sku_id: this.skuId
      })
    }
  }
}
</script>
<style lang="scss" scoped src="./index.scss"></style>
